import React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import config from '../../data/SiteConfig'

export default class MarkdownPage extends React.Component {
  render() {
    const { slug } = this.props.pathContext
    const pageNode = this.props.data.markdownRemark
    const meta = pageNode.frontmatter

    return (
      <PageContainer>
        <Helmet>
          <title>{`${meta.title} | ${config.siteTitle}`}</title>
        </Helmet>
        <PageBody>
          <div dangerouslySetInnerHTML={{ __html: pageNode.html }} />
        </PageBody>
      </PageContainer>
    )
  }
}

const PageContainer = styled.div`
  margin: 200px 0 100px;
  min-height: 45vh;

  @media screen and (max-width: 768px) {
    width: 90%;
    margin: 50px auto;
  }
`

const PageBody = styled.div`
  max-width: 800px;
  margin: auto;

  & * {
    p,
    h1,
    h2 {
      margin-bottom: 30px;
    }
  }
`

/* eslint no-undef: "off"*/
export const pageQuery = graphql`
  query MarkdownPage($slug: String) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/markdown_page.jsx